var app_campaigns_table = $('#app-campaigns-table');

if (app_campaigns_table.length) {
    var data_table_order = [ 9, "desc" ];
    function initializeCampaignsTable() {
        var advertiser = $('#app-campaigns-table').attr('data-advertiser');
        var has_order=0;
        $('#app-campaigns-table').DataTable({
            "processing": true,
            "serverSide": true,
            ajax: {
                url: '/advertisers/' + advertiser + '/campaigns/list',
                dataSrc: 'data',
            },
            order: data_table_order,
            columns: [
                {data: 'orders'},//0
                {data: 'name'},//1
                {data: 'date_range'},//2
                {data: 'brand'},//3
                {data: 'product'},//4
                {data: 'budget'},//5
                {data: 'ordered'},//6
                {data: 'created_at'},//7
                {data: 'created_by_name'},//8
                {data: 'last_accessed'},//9
                {data: 'estimate_number'},//10
                {data: 'proposal_sent'},//11
                {data: 'slug'} // 12
            ],
            destroy: true,
            pageLength: user_entries,
            "columnDefs": [
                {
                    "targets": 0,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log(cellData);
                        var orders= cellData.split('_');
                        if(orders[1]=='')
                            has_order=1;
                        else
                            has_order=0;
                            var html = ' <div class="checkbox checkbox-danger campaigns_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + orders[0] + '" name="selected_campaigns[]" value="' + orders[0] + '" ><label for="'+orders[0]+'"> </label></div>';

                        $(td).html(html);
                    }
                },
                {
                    "targets": 1,
                    "orderable": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log('rowData......', rowData);
                        console.log('row......', row);
                        $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                    }
                },
                {
                    "targets": 5,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html('$ ' + cellData.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                    }
                },
                {
                    "targets": 6,
                    "orderable": false,
                    "visible": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log('all row rowData ', rowData);
                        $(td).html('$ ' + cellData.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                    }
                },
                {
                    "targets": 3,
                    "orderable": false,
                    "visible": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = (typeof rowData.brand !== 'undefined' && rowData.brand !== null) ? rowData.brand : '';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 4,
                    "orderable": false,
                    "visible": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = (typeof rowData.product !== 'undefined' && rowData.product !== null) ? rowData.product : '';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 7,
                    "orderable": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                        $(td).html(date.format('MM/DD/YYYY'));
                    }
                },
                {
                    "targets": 9,
                    "orderable": true,
                },
                {
                    "targets": 11,
                    "orderable": false,
                },
                {
                    "targets": 12,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log('rowData', rowData);
                        var html = '';
                        html += '<div  class="btn-group" role="group"><a  href="/advertisers/' + advertiser + '/campaigns/' + cellData + '" role="button" class="btn btn-primary btn-sm btn-outline" title="Edit Campaign">' +
                            '<i class="fa fa-pencil"></i> ' +
                            '</a></div>';
                        html += '<div style="margin-left: 5px" class="btn-group" role="group"><a  href="javascript:void(0)" onclick="archiveAdvertiserCampaign(\'/advertisers/' + advertiser + '/campaigns/' + cellData + '/archive\')" role="button" class="btn btn-primary btn-sm btn-outline" title="Archive Campaign">' +
                            '<i class="fa fa-archive"></i> ' +
                            '</a></div>';
                        html += '<div style="margin-left: 5px" class="btn-group" role="group"><a  href="javascript:void(0)" onclick="deleteAdvertiserCampaign(\'/advertisers/' + advertiser + '/campaigns/' + cellData + '/destroy\', ' + has_order + ')" role="button" class="btn btn-primary btn-sm btn-outline" title="Delete Campaign">' +
                            '<i class="fa fa-trash-o"></i> ' +
                            '</a></div>';
                        html += ' <div class="btn-group" role="group">' +
                            ' <button title="Proposal Report" type="button" class="btn btn-primary btn-outline btn-sm dropdown-toggle btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">' +
                            '<i class="fa fa-send"></i> <span class="caret"></span> ' +
                            ' </button>';
                        html += '<ul class="dropdown-menu">' +
                            '<li><a style="background-color: white; color: dimgray; font-size: 13px" row-id="' + row + '" data-id="' + rowData.id + '" class="proposal_report" href="#"> Send</a></li>' +
                            '<li><a style="background-color: white; color: dimgray; font-size: 13px" data-id="' + rowData.id + '" class="proposal_details" href="#">  Details</a></li>';
                        html += '</ul></div>';

                        $(td).html(html);
                    }
                }
            ]
        });
    }

    $('#app-campaigns-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });
    $('#app-campaigns-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order=[len[0].col, ""+len[0].dir+""];
    } );

    $('#select_all_camp').on('click', function (e) {
        $('#app-campaigns-table input:checkbox').prop('checked', true);
    });
    $('#deselect_all_camp').on('click', function (e) {
        $('#app-campaigns-table input:checkbox').prop('checked', false);
    });

    //Delete Campaign
    $('#delete_multiple_camp').on('click', function (e) {
        var url = $(this).attr('data-url');
        var selectedItems = [];
        $('.campaigns_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        if (selectedItems.length > 0) {
            show_loader();
            var url_one = '/adv/has_order/multiple_delete/confirm';
            var params = {
                campaigns: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url_one,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    if (response.length > 0) {
                        if (selectedItems.length > 1)
                            var mess = 'Some selected campaigns has created orders. Are you sure to delete?';
                        else
                            var mess = 'The selected campaign has created orders. Are you sure to delete?';
                    } else
                        var mess = "Are you sure to delete the selected campaigns?";
                    $('#deleteCampWarningDiv').html(mess);
                    $('#deletedCampMultConfirm').attr('data-url', url)
                    $('#deletedCampMultConfirm').show();
                    $('#deletedCampConfirm').hide();
                    $('#deleteCampWarningModal').modal('show');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });

        } else {
            $('#generalWarningModalDiv').html('Select at least one Campaign.');
            $('#generalWarningModal').modal('show');
        }
    });
    function deletedCampMultConfirm(){
        show_loader();
        var urlVar = $('#deletedCampMultConfirm').attr('data-url');
        var selectedItems = [];
        $('.campaigns_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var params = {
            campaigns: selectedItems,
        };
       console.log('urlVar urlVar ', urlVar);
        console.log('urlVar selectedItems', selectedItems);
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: urlVar,
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                global_notification('success', 'Campaigns deleted.');
                initializeCampaignsTable();
                $('#deleteCampWarningModal').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });
    }
    function deleteAdvertiserCampaign(urlVar, hav_order) {
        console.log(urlVar);
        if (hav_order == 0)
            var mess = "This campaign has created orders. Are you sure to delete?";
        else
            var mess = "Are you sure to delete this campaign?";

        $('#deleteCampWarningDiv').html(mess);
        $('#deletedCampConfirm').attr('data-url', urlVar)
        $('#deletedCampConfirm').show();
        $('#deletedCampMultConfirm').hide();
        $('#deleteCampWarningModal').modal('show');
    }
    function deletedCampConfirm() {
        show_loader();
        var urlVar = $('#deletedCampConfirm').attr('data-url');
        $.ajax({
            url: urlVar,
            success: function (response) {
                global_notification('success', 'Campaign deleted.');
                $('#deleteCampWarningModal').modal('hide');
                initializeCampaignsTable();
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });
    }

    //Archive Campaigns
    $('#archive_camp').on('click', function (e) {
        var selectedItems = [];
        $('.campaigns_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        if (selectedItems.length > 0) {
            $('#select_year').select2({
                placeholder: "Select one...",
                minimumResultsForSearch: Infinity
            })
            $('#selectYearArchiveModal').modal('show');
        }
        else{
            $('#generalWarningModalDiv').html('Select at least one Campaign.');
            $('#generalWarningModal').modal('show');
        }
    });
    $('#confirm_archive').on('click', function (e) {
        var year = $('#select_year option:selected').val();
        if (year == '') {
            $('#generalWarningModalDiv').html('Please select the year.');
            $('#generalWarningModal').modal('show');
        }
        else{
            var url = $('#archive_camp').attr('data-url');
                $('#archiveCampWarningDiv').html("Are you sure to archive the selected campaigns?");
                $('#archiveCampConfirm').hide();
                $('#archiveCampMultConfirm').show();
                $('#archiveCampMultConfirm').attr('data-url', url);
                $('#archiveCampWarningModal').modal('show');
        }
    });
    $('#confirm_archive_single').on('click', function (e) {
        var year = $('#select_year_single option:selected').val();
        if (year == ''){
            $('#generalWarningModalDiv').html('Please select the year.');
            $('#generalWarningModal').modal('show');
        }
        else {
            var urlVar =$(this).attr('data-url');
            urlVar = urlVar+ '/'+year;
            console.log(urlVar);
            $('#archiveCampWarningDiv').html("Are you sure to archive this campaign?");
            $('#archiveCampConfirm').show();
            $('#archiveCampMultConfirm').hide();
            $('#archiveCampConfirm').attr('data-url', urlVar);
            $('#archiveCampWarningModal').modal('show');
        }
    });
    function archiveAdvertiserCampaign(urlVar) {
       $('#select_year_single').select2({
           placeholder: "Select one...",
           minimumResultsForSearch: Infinity
       });
       $('#confirm_archive_single').attr('data-url', urlVar);
       $('#selectYearArchiveModalSingle').modal('show');
    }
    function archiveCampMultConfirm(){
        show_loader();
        var year = $('#select_year option:selected').val();
        var selectedItems = [];
        $('.campaigns_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        $('#selectYearArchiveModal').modal('hide');
        $('#archiveCampWarningModal').modal('hide');
        var params = {
            campaigns: selectedItems,
            year: year,
        };
        var url = $('#archiveCampMultConfirm').attr('data-url');
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: url,
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                global_notification('success', 'Campaign archived...');
                initializeCampaignsTable();
                if ($('#to_knew_view').attr('data-exist') == 'yes')
                    initializeCampaignsArchivedTable(response.year, 1);
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });
    }
    function archiveCampConfirm(){
        show_loader();
        var urlVar =  $('#archiveCampConfirm').attr('data-url');
        $('#selectYearArchiveModalSingle').modal('hide');
        $('#archiveCampWarningModal').modal('hide');
        $.ajax({
            url: urlVar,
            success: function (response) {
                global_notification('success', 'Campaign archived...');
                initializeCampaignsTable();
                if ($('#to_knew_view').attr('data-exist') == 'yes')
                    initializeCampaignsArchivedTable(response.year, 1);
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });

    }

    initializeCampaignsTable();

    //Porposal Report
    $('#app-campaigns-table').on('click', '.proposal_report', function (){
        show_loader();
        $("#proposal_options").multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_proposal" value="Select All" id="select_all_proposal">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm deselect_all_proposal' value='Deselect All' id='deselect_all_proposal'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });
        $('#proposalReportModal').modal('show');
        $("#select_all_proposal").on("click", function(){
            $('#proposal_options').multiSelect("select_all").multiSelect('refresh');
        });
        $("#deselect_all_proposal").on("click", function(){
            $('#proposal_options').multiSelect("deselect_all").multiSelect('refresh');
        });
        var id = $(this).attr('data-id');
        var row_id = $(this).attr('row-id');
        $('#send_proposal_report_multiple_rep').attr('campaign-id', id);
        $('#send_proposal_report_multiple_rep').attr('row-id', row_id);
        $('#send_proposal_report_multiple_rep').attr('view-id', 'adv');
        $.ajax({
            type: 'GET',
            url: '/campaigns/proposal_report/get_rep_emails/' + id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var html = '<label >Copy to: </label> ';
                html += '<div class="form-inline form row m-b-12 email-cc-row-group">';
                html += '<div class="col-sm-9 email-cc-container-group"><div class="ui-widget ui-front">';
                html += ' <input autocomplete="nope" id="cc_group_1" name="cc_group_1" class="form-control full-width brand " type="email" placeholder="username@email.com" value="'+ data.user.email + '"></div></div>';
                html += ' <div class="col-sm-3 m-t-10 email-cc-container-group">';
                html += '<button type="button" class="btn btn-info btn-outline" id="add_gruop_cc" data-number="1"><i class="fa fa-plus fa-fw "></i>Add Copy</button> </div> </div>';
                $(".cc-dic-form_group").html(html);
                $('#cc_count_group').val(1);

                var html = data.html;
                console.log('html_html ', html)
                $("#select_rep_email").multiSelect({
                    selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_proposal_rep" value="Select All" id="select_all_proposal_rep">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm deselect_all_proposal_rep' value='Deselect All' id='deselect_all_proposal_rep'>" +'</div>',
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values) {

                    },
                    afterDeselect: function(values){

                    }
                });
                $('#select_rep_email').html(html)
                $('#select_rep_email').multiSelect('refresh');
                $('#sendGroupEmailProposalModal').modal('show');

                $("#select_all_proposal_rep").on("click", function(){
                    $('#select_rep_email').multiSelect("select_all").multiSelect('refresh');
                });
                $("#deselect_all_proposal_rep").on("click", function(){
                    $('#select_rep_email').multiSelect("deselect_all").multiSelect('refresh');
                });
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
            }
        });

    });
    $('#app-campaigns-table').on('click', '.proposal_details', function (){
        var c_id = $(this).attr('data-id');
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/campaigns/proposal/get_details/' + c_id,
            dataType: 'json',
            encode: true,
            success: function (rowData) {
                $('#proposalSentGrid').html('');
                gridProposalSentDetails.rowData = rowData;
                var gridDet = document.querySelector('#proposalSentGrid');
                var g4 = new agGrid.Grid(gridDet, gridProposalSentDetails);
                $('#ProposalSentDetailsModal').modal('show');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

}
